import fp from 'lodash/fp';
import React from 'react';

export const logX = fp.flow(
  fp.over([fp.identity, console.log]),
  fp.head
);

/*
 * A couple of "print to screen" style debuging functions. Put these in the "compose(...)" and they whack some HTML with the result of
 * propsFunc on the props as they stand in the compose chain.
 */
export const addHTMLToStart = propsFunc => (component => (props => <div> <pre> {propsFunc(props)} </pre> {component(props)} </div>));
export const printProp = (propName, propFunc) => addHTMLToStart(props => `${propName}:\n${JSON.stringify(propFunc(props), undefined, 2)}`) 



// WEBPACK FOOTER //
// ./src/utils/debug.js